import { auth } from '@/lib/firebase';
import { OAuthProvider, signInWithPopup } from 'firebase/auth';

export async function signInWithApple(): Promise<void> {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');
  await signInWithPopup(auth, provider);
}
